import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MapPin, Truck } from 'lucide-react';
import { api } from '../../services/api';
import { useActiveVisit } from '../../contexts/ActiveVisitContext';
import type { DeliveryTour } from '../../types/deliveryTour';
import { ActiveWorkFab } from './ActiveWorkFab';

export const ActiveWorkFabCluster: React.FC = () => {
  const location = useLocation();
  const { hasDraft } = useActiveVisit();
  const [tour, setTour] = useState<DeliveryTour | null>(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get('/delivery-batches/current');
      setTour(res.data || null);
    } catch {
      setTour(null);
    }
  }, []);

  useEffect(() => {
    void load();
    const onFocus = () => void load();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [load, location.pathname]);

  const showDelivery =
    Boolean(tour) && !location.pathname.startsWith('/delivery-batches');
  const showVisit = hasDraft && location.pathname !== '/visits/new';

  if (!showDelivery && !showVisit) return null;

  return (
    <div className="fixed bottom-4 left-4 z-40 flex items-center gap-3">
      {showDelivery ? (
        <ActiveWorkFab
          icon={Truck}
          label="Current delivery"
          to="/delivery-batches"
          pathId="fab-delivery"
        />
      ) : null}
      {showVisit ? (
        <ActiveWorkFab
          icon={MapPin}
          label="Current visit"
          to="/visits/new"
          pathId="fab-visit"
        />
      ) : null}
    </div>
  );
};
